export default __webpack_public_path__ + "static/media/logo.30d09321.png";